import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: 'b15ff5f2-eb29-417d-99dd-6f4629a45a94',
  name: 'Draft',
  description: "The Issue has been created but isn't ready for submittal yet",
  priority: 0,
})

const PendingResponse = new StatusEnumItem({
  id: 'da3f66a7-5fff-4ca0-9c9c-c8f7b10a2253',
  name: 'Pending Response',
  description: 'The Issue has been submitted and is waiting for a response',
  priority: 1,
})

const PendingDisposition = new StatusEnumItem({
  id: 'cd78983d-ecfe-4773-8619-f5da90e8a5f4',
  name: 'Pending Disposition',
  description:
    'The Issue has received a response and is waiting for a disposition type',
  priority: 2,
})

const PendingClosure = new StatusEnumItem({
  id: 'f197a461-5d8c-4c12-a765-9bd8f346fbd8',
  name: 'Pending Closure',
  description:
    'The Issue has receievd a disposition type and is waiting for closure notes',
  priority: 3,
})

const Closed = new StatusEnumItem({
  id: 'e4ff5800-9b1a-4043-827c-7c365d674a95',
  name: 'Closed',
  description:
    'The Issue has completely gone through the Issue Tracker workflow and its associated SharePoint folder is locked. Limited fields are editable',
  priority: 4,
})

const Unlocked = new StatusEnumItem({
  id: 'c8478c92-d40e-41e9-aa4c-d7d8d05019f5',
  name: 'Unlocked',
  description: 'The Issue has been unlocked in CIMS and SharePoint for editing',
  priority: 5,
})

export type IssueStatusItem =
  | typeof Draft
  | typeof PendingResponse
  | typeof PendingDisposition
  | typeof PendingClosure
  | typeof Closed
  | typeof Unlocked
class IssueStatusEnum extends StatusEnum<
  'IssueStatus',
  IssueStatusItem,
  IssueStatusItem['name'],
  IssueStatusItem['id'],
  IssueStatusItem['priority']
> {
  readonly typename = 'IssueStatus' as const
  get values() {
    return [
      this.Draft,
      this.PendingResponse,
      this.PendingDisposition,
      this.PendingClosure,
      this.Closed,
      this.Unlocked,
    ]
  }
  readonly Draft = Draft
  readonly PendingResponse = PendingResponse
  readonly PendingDisposition = PendingDisposition
  readonly PendingClosure = PendingClosure
  readonly Closed = Closed
  readonly Unlocked = Unlocked
}
/**
 * @see {@link IssueStatusEnum}
 * @see {@link IssueStatusItem}
 */
export const IssueStatus = new IssueStatusEnum()
